import {
  FETCH_JOB_APPLICATION_LIST,
  FETCH_JOB_APPLICATION_LIST_SUCCESS,
  FETCH_JOB_APPLICATION_LIST_FAILURE,
  CREATE_JOB_APP_CUSTOM_VIEW,
  CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS,
  CREATE_JOB_APP_CUSTOM_VIEW_FAILURE,
  FETCH_JOB_APP_CUSTOM_VIEW,
  FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS,
  FETCH_JOB_APP_CUSTOM_VIEW_FAILURE,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_JOB_APP_CUSTOM_VIEW,
  UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS,
  UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE,
  REJECT_JOB_APPLICATION_BY_ID,
  REJECT_JOB_APPLICATION_BY_ID_SUCCESS,
  REJECT_JOB_APPLICATION_BY_ID_FAILURE,
  FETCH_CANDIDATE_ID_BY_EMAIL,
  FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS,
  FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE,
  RESET_JOB_APPLICATION_LIST,
  SET_JOB_APP_DEFAULT_CUSTOM_VIEW,
  DELETE_JOB_APP_DEFAULT_CUSTOM_VIEW,
  RESET_JOB_APP_CUSTOM_VIEW,
  SET_LOADING,
  SET_APPROVE_ACTION,
  SET_APPROVE_SUCCESS,
  SET_CANDIDATE_ID
} from "./actionTypes";

const initialState = {
  jobApplicationList: [],
  jobAppDefaultCustomView: {},
  jobAppCustomView: {},
  jobAppCustomViews: [],
  candidateId: "",
  approveAction: false,
  approveSuccess: false,
  loading: false,
  error: false,
  errorMsg: "",
};

const JobApplicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOB_APPLICATION_LIST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_JOB_APPLICATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        jobApplicationList: action.payload,
      };
    case FETCH_JOB_APPLICATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case CREATE_JOB_APP_CUSTOM_VIEW:
      return {
        ...state,
        error: false,
      };
    case CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        jobAppCustomView: action.payload,
      };
    case CREATE_JOB_APP_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW:
      return {
        ...state,
        error: false,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        jobAppCustomViews: action.payload,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        error: false,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        jobAppCustomView: action.payload,
      };
    case FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case DELETE_JOB_APP_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        error: false,
      };
    case DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        jobAppCustomView: {},
      };
    case DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload
      };
    case SELECT_JOB_APP_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        error: false,
      };
    case SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        jobAppCustomView: action.payload,
      };
    case SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case UNSELECT_JOB_APP_CUSTOM_VIEW:
      return {
        ...state,
        error: false,
      };
    case UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS:
      const newJobAppCustomViews = state.jobAppCustomViews.map((view) => {
        if (view?.selected === true) {
          view.selected = false;
        }
        return view;
      });
      return {
        ...state,
        jobAppCustomViews: newJobAppCustomViews,
      };
    case UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case EDIT_JOB_APP_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        error: false,
      };
    case EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        jobAppCustomView: action.payload,
      };
    case EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case UPDATE_JOB_APPLICATION_STATUS_BY_ID:
      return {
        ...state,
        error: false,
      };
    case UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload,
      };
    case REJECT_JOB_APPLICATION_BY_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case REJECT_JOB_APPLICATION_BY_ID_SUCCESS:
      return {
        ...state,
      };
    case REJECT_JOB_APPLICATION_BY_ID_FAILURE:
      return {
        ...state,
        error: true,
        errorMsg: action.payload
      };
    case FETCH_CANDIDATE_ID_BY_EMAIL:
      return {
        ...state,
        loading: true,
        approveAction: true,
        error: false,
      };
    case FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS:
      return {
        ...state,
        candidateId: action.payload,
      };
    case FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case RESET_JOB_APPLICATION_LIST:
      return {
        ...state,
        jobApplicationList: [],
      };
    case SET_JOB_APP_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        jobAppDefaultCustomView: action.payload,
      };
    case DELETE_JOB_APP_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        jobAppDefaultCustomView: {},
      };
    case RESET_JOB_APP_CUSTOM_VIEW:
      return {
        ...state,
        jobAppCustomViews: {},
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_APPROVE_ACTION:
      return {
        ...state,
        approveAction: action.payload,
      };
    case SET_APPROVE_SUCCESS:
      return {
        ...state,
        approveSuccess: action.payload,
      };
    case SET_CANDIDATE_ID:
      return {
        ...state,
        candidateId: action.payload,
      };
    default:
      return state;
  }
}

export default JobApplicationReducer;